import { Star, Quote } from "lucide-react";
import { Card, CardContent } from "./ui/card";

const testimonials = [
  {
    id: 1,
    name: "Rajesh Sharma",
    location: "Skyline Residences, Unit 12A",
    image: "https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?w=150&h=150&fit=crop&crop=face",
    rating: 5,
    text: "The attention to detail and quality of construction exceeded our expectations. The amenities are world-class, and the location is perfect for our family's needs.",
    highlight: "Exceptional Quality"
  },
  // {
  //   id: 2,
  //   name: "Priya Patel",
  //   location: "Vista Heights, Penthouse 3B",
  //   image: "https://images.unsplash.com/photo-1494790108755-2616b612b786?w=150&h=150&fit=crop&crop=face",
  //   rating: 5,
  //   text: "From the initial booking to possession, the entire process was transparent and professional. The customer service team was always available to address our concerns.",
  //   highlight: "Transparent Process"
  // },
  // {
  //   id: 3,
  //   name: "Amit Kumar",
  //   location: "Garden Estates, Villa 7C",
  //   image: "https://images.unsplash.com/photo-1472099645785-5658abf4ff4e?w=150&h=150&fit=crop&crop=face",
  //   rating: 5,
  //   text: "Living here feels like a resort experience every day. The green spaces, amenities, and community atmosphere make it the perfect place to raise our children.",
  //   highlight: "Resort-like Living"
  // }
];

const Testimonials = () => {
  return (
    <section className="py-20 bg-background">
      <div className="container mx-auto px-6">
        <div className="text-center mb-16 animate-fade-up">
          <h2 className="font-display-bold text-4xl md:text-5xl text-primary mb-6">
            What Our Residents Say
          </h2>
          <p className="text-xl text-muted-foreground max-w-3xl mx-auto">
            Experience the satisfaction of thousands of families who have made 
            our properties their home and investment choice.
          </p>
        </div>

        <div className="grid lg:grid-cols-3 gap-8 mb-16">
          {testimonials.map((testimonial, index) => (
            <Card
              key={testimonial.id}
              className="luxury-card relative animate-fade-up"
              style={{ animationDelay: `${index * 0.2}s` }}
            >
              <CardContent className="p-8">
                <div className="absolute top-6 right-6 text-luxury-muted">
                  <Quote className="h-8 w-8" />
                </div>

                <div className="flex items-center mb-6">
                  <img
                    src={testimonial.image}
                    alt={`${testimonial.name} - satisfied customer`}
                    className="w-16 h-16 rounded-full object-cover border-2 border-luxury-muted mr-4"
                  />
                  <div>
                    <h3 className="font-display text-lg text-primary font-medium">
                      {testimonial.name}
                    </h3>
                    <p className="text-sm text-muted-foreground">
                      {testimonial.location}
                    </p>
                    <div className="flex items-center mt-1">
                      {[...Array(testimonial.rating)].map((_, i) => (
                        <Star key={i} className="h-4 w-4 fill-luxury text-luxury" />
                      ))}
                    </div>
                  </div>
                </div>

                <blockquote className="text-muted-foreground leading-relaxed mb-4 italic">
                  "{testimonial.text}"
                </blockquote>

                <div className="inline-block bg-luxury-muted text-luxury px-3 py-1 rounded-full text-sm font-medium">
                  {testimonial.highlight}
                </div>
              </CardContent>
            </Card>
          ))}
        </div>

        {/* Trust Metrics */}
        <div className="grid md:grid-cols-4 gap-8 mt-16">
          {[
            { metric: "4.9/5", label: "Customer Rating", desc: "Based on 2,500+ reviews" },
            { metric: "98%", label: "Satisfaction Rate", desc: "Customer retention" },
            { metric: "24/7", label: "Support Available", desc: "Dedicated helpdesk" },
            { metric: "15+", label: "Years Experience", desc: "Industry expertise" }
          ].map((item, index) => (
            <div
              key={index}
              className="text-center animate-fade-up"
              style={{ animationDelay: `${index * 0.1}s` }}
            >
              <div className="text-3xl md:text-4xl font-display-bold text-luxury mb-2">
                {item.metric}
              </div>
              <div className="font-medium text-primary mb-1">{item.label}</div>
              <div className="text-sm text-muted-foreground">{item.desc}</div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Testimonials;